import React from 'react';
import useManageSecondaryEmailsPage from "v4/pages/admin/ManageSecondaryEmailsPage/hooks/useManageSecondaryEmailsPage";
import AdminCard from "v4/components/ui/AdminCard/AdminCard";
import {useTranslation} from "react-i18next";
import InlineLoader from "v4/components/ui/InlineLoader/InlineLoader";
import FormRender from "v4/components/form/FormRender/FormRender";
import SubmitButton from "v4/components/ui/SubmitButton/SubmitButton";

export default function ManageSecondaryEmailsPage() {
    const {t} = useTranslation();
    const {
        form,
        errorData,
        methods,
        onSubmit,
        isLoading,
        isFormSubmitting,
    } = useManageSecondaryEmailsPage();

    return (
        <AdminCard
            title={t('manage_secondary_emails')}
            CardHeaderTools={() => form && (
                <SubmitButton formId="manage_secondary_emails" isLoading={isFormSubmitting}>
                    {t('sauvegarder')}
                </SubmitButton>
            )}
        >
            {isLoading && <InlineLoader text={t('loading')}/>}
            <FormRender formId="manage_secondary_emails"
                        form={form}
                        formErrors={errorData}
                        methods={methods}
                        onSubmit={onSubmit}
            />
        </AdminCard>
    )
}
